<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import EnSpinnerWrapper from 'Components/feedback/EnSpinner/EnSpinnerWrapper.vue';

const modelValue = defineModel('modelValue');
const {t} = useI18n();

/**
 * A simple loading spinner.
 */
const props = defineProps({
  /**
   * The color of the loading spinner.
   * Is not applied if overlay is set to true.
   */
  // TODO(VHA): Change overlay spinner color scheme considering color.
  color: {
    type: String,
    default: '$en-blue',
  },
  /**
   * Specifies whether the loading spinner should be displayed in big variant (true) or not (false).
   * Big variant increases the font-size, height and width.
   */
  big: {
    type: Boolean,
    default: false,
  },
  /**
   * Whether the spinner is an overlay (true) or not (false).
   */
  overlay: Boolean,
  /**
   * Text displayed next to the overlay loading spinner.
   */
  overlayText: {
    type: String,
  }
});

const style = computed(() => {
  return {
    'border-top-color': props.overlay ? 'white' : props.color,
  };
});

const cssClass = computed(() => {
  return {
    'en-spinner': true,
    'en-spinner--big': props.big,
    'en-spinner--normal': !props.big,
  };
});

const textComputed = computed(() => {
  return props.overlayText ?? t('common.loading');
});

</script>

<template>
  <en-spinner-wrapper :overlay="overlay" :model-value="modelValue">
    <span :class="cssClass" :style="style"></span>
    <template v-if="overlay">{{ textComputed }}</template>
  </en-spinner-wrapper>
</template>

<style lang="scss" scoped>
@use "Styles/helper/variables";

.en-spinner {
  border-radius: 50%;
  border-style: solid;
  border-color: transparent;
  border-top-color: variables.$en-blue;
  animation: spin 1s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
}

// TODO(VHA): Use typography variables
.en-spinner--normal {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

// TODO(VHA): Use typography variables
.en-spinner--big {
  font-size: 40px;
  width: 40px;
  height: 40px;
}
</style>
